import jQuery from "jquery";
import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { SaveIcon, TimeCodeArrowIcon } from "../AppIcons";
import Constants from "../Constants";
import { ConditionalBlock } from "../ConditionalBlock";
import { RotatingLines } from "react-loader-spinner";
import { putAxiosResponse, handleError} from "../services/authApiRoutes/APImethods";
import APIUrls from "../services/APIUrls";

export default function TimeCode(props) {

    const [startTime, setStartTime] = useState(props.startTime);
    const [endTime, setEndTime] = useState(props.endTime);
    const [dirty, setDirty] = useState(false);
    const [inProgress, setInProgress] = useState(false);

    useEffect(() => {
        setStartTime(props.startTime);
        setEndTime(props.endTime);
    }, [props.startTime, props.endTime]);

    const currentUser = useSelector(store => store.customer_bootstrap_data).value.user;

    jQuery(document).on("keyup", '#tc-st-'+props.tuId+',#tc-et-'+props.tuId, function (event) {
        let startTimeVal = jQuery('#tc-st-'+props.tuId).html();
        let endTimeVal = jQuery('#tc-et-'+props.tuId).html();
        if(startTimeVal.trim() !== startTime || endTimeVal.trim() != endTime){
            setDirty(true);
        }
    });

    jQuery(document).on("blur", '#tc-st-'+props.tuId+',#tc-et-'+props.tuId, function (event) {
        let startTimeVal = jQuery('#tc-st-'+props.tuId).html();
        let endTimeVal = jQuery('#tc-et-'+props.tuId).html();
        setStartTime(startTimeVal);
        setEndTime(endTimeVal);
        setDirty(true);
    });


    const timeCodeToMillis = (timecodeString) => {
        let parts = timecodeString.split(/[:,]/);
        if(parts.length == 4) {
            return (((+parts[0]) * 3600 + (+parts[1]) * 60 + (+parts[2])) * 1000) + (+parts[3]);
        }
        return 0;
    }

    const validateAndSave = (e) => {
        let timeCodePattern = /([0-9]?[0-9]{1}|2[0-3]{1}):[0-5]{1}[0-9]{1}:[0-5]{1}[0-9]{1},[0-9]{1}[0-9]{1}[0-9]{1}/
        let inValid = false;
        if(!timeCodePattern.test(startTime.trim()) || !timeCodePattern.test(endTime.trim())){
            setStartTime(props.startTime);
            setEndTime(props.endTime);
            inValid = true;
        }

        if(inValid){
            setDirty(false);
        }else{
            setDirty(false);
            setInProgress(true);
            let timeCodes = {};
            timeCodes.startTimeMs = timeCodeToMillis(startTime.trim());
            timeCodes.endTimeMs = timeCodeToMillis(endTime.trim());
            timeCodes.userId = currentUser.userId;

            putAxiosResponse(APIUrls.CUSTOMER_TIMECODE_TRANSLATION_UNIT(props.tuId), timeCodes).then(res=>{
                setInProgress(false);
            }).catch(err=>{
                setInProgress(false);
                handleError(err);
            });
        }
    }

    return (
        <div class="date-outer">
            <div class="date-inner">
                <span className="outsideContext">
                    <span contenteditable="true" id={"tc-st-"+props.tuId}>{startTime}</span>
                </span>
                {TimeCodeArrowIcon}
                <span className="outsideContext">
                    <span contenteditable="true" id={"tc-et-"+props.tuId}>{endTime}</span>
                </span>
                <ConditionalBlock condition={dirty === true}>
                    <button onClick={validateAndSave}>
                        {SaveIcon}
                    </button>
                </ConditionalBlock>
                <RotatingLines
                    strokeColor="#757171"
                    strokeWidth="5"
                    animationDuration="0.75"
                    width="16"
                    visible={inProgress}
                />
            </div>
        </div>
    )
}